import { NEWSLETTERS_API } from 'modules/newsletters/single/api/newsletters-api'
import { NewsletterId } from 'modules/newsletters/single/types/newsletter-interface'
import { NewsletterSplitTestInterface } from 'modules/newsletters/split-test/types/newsletter-split-test-interface'
import { useFetch } from 'shared/hooks/use-fetch'
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types'

export const useCreateSplitTest = () => {
  const { fetcher, isFetching } = useFetch<RequestMethodsEnum.post, NewsletterSplitTestInterface>({
    method: RequestMethodsEnum.post,
  })
  return {
    createSplitTest: (newsletterId: NewsletterId) =>
      fetcher(`${NEWSLETTERS_API}/${newsletterId}/split-test`),
    isFetching,
  }
}
